import { render } from "./EnquiriesViewFullKit.vue?vue&type=template&id=a8437012"
import script from "./EnquiriesViewFullKit.vue?vue&type=script&lang=js"
export * from "./EnquiriesViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__